/**
 * The web fonts a drawn visual may load: a short, curated list of Google Fonts families (display,
 * comic, condensed, serif and mono looks). Mirrors magic-core's `CURATED_FONTS`; nothing outside
 * this list is ever loaded.
 */
export const CURATED_FONTS = [
  "Inter",
  "Roboto Slab",
  "Playfair Display",
  "Merriweather",
  "Oswald",
  "Bebas Neue",
  "Anton",
  "Bangers",
  "Comic Neue",
  "Press Start 2P",
  "Orbitron",
  "Space Grotesk",
  "JetBrains Mono",
  "Caveat",
] as const;

export type CuratedFont = (typeof CURATED_FONTS)[number];

/** The curated family a name stands for (case and outer spaces ignored), or null for anything else. */
export const toCuratedFont = (name: string | null | undefined): CuratedFont | null => {
  if (typeof name !== "string") return null;
  const wanted = name.trim().toLowerCase();
  return CURATED_FONTS.find((font) => font.toLowerCase() === wanted) ?? null;
};

/** The Google Fonts stylesheet for a curated family (spaces as `+`), `display=swap`. */
export const toGoogleFontsHref = (font: CuratedFont, weights: number[] = []): string =>
  `https://fonts.googleapis.com/css2?family=${encodeURIComponent(font).replace(/%20/g, "+")}${weights.length > 0 ? `:wght@${weights.join(";")}` : ""}&display=swap`;
